export default __webpack_public_path__ + "static/typography-image-v-54c2f444141252f282410ff3c3041cdf2b31c6ba5cb9ce6284a0bfd91e1ff074.png";